import * as React from "react";

type ArrowRightProps = React.SVGProps<SVGSVGElement> & {
  size?: "sm" | "lg";
};

const ArrowRight = React.forwardRef<SVGSVGElement, ArrowRightProps>(
  ({ size = "sm", className, ...props }, ref) => {
    const dimensions = size === "lg" ? 20 : 16;

    return (
      <svg
        ref={ref}
        width={dimensions}
        height={dimensions}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className={`arrow-right ${className || ""}`}
        {...props}
      >
        <path
          className="arrow-stem"
          d="M4.16663 10H15.8333"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="arrow-head"
          d="M10 4.16669L15.8333 10L10 15.8334"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);

ArrowRight.displayName = "ArrowRight";

export { ArrowRight };
